import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import * as FinanceInterfaceConstants from '@/class/cargo/model/parameters/FinanceInterfaceConstants'
import * as CompanyConstants from '@/class/cargo/model/parameters/CompanyConstants'
import store from '@/store'

class FinanceUtil {
  constructor() {}

  /**
   * 获取相应的财务编码映射
   */
  static getMappingCode(accountSet, mappingType, baseDataValue) {
    let code = ''
    for (const mapping of accountSet.financeCodeMapping) {
      if (mapping.baseDataType === mappingType && mapping.baseDataValue === baseDataValue) {
        code = mapping.financeCode
        break
      }
    }
    return code
  }

  /**
   * 凭证分组类型
   */
  static businessDataTypeLabelFunc(value) {
    const state = CommonState.getStateByCode(FinanceInterfaceConstants.BIZ_DATA_TYPES, value)
    return state == null ? '' : (store.getters.isZh ? state.chineseName : state.englishName)
  }

  /**
   * 记账方式
   */
  static accountingModeLabelFunc(value) {
    const state = CommonState.getStateByCode(FinanceInterfaceConstants.ACCOUNTING_MODES, value)
    return state == null ? '' : (store.getters.isZh ? state.chineseName : state.englishName)
  }

  /**
   * 凭证分组维度
   */
  static groupingDimensionLabelFunc(value) {
    const state = CommonState.getStateByCode(FinanceInterfaceConstants.GROUPING_DIMENSIONS, value)
    return state == null ? '' : (store.getters.isZh ? state.chineseName : state.englishName)
  }

  /**
   * 分录分组类型
   */
  static entryTypeLabelFunc(value) {
    const state = CommonState.getStateByCode(FinanceInterfaceConstants.ENTRY_TYPES, Number(value))
    return state == null ? '' : (store.getters.isZh ? state.chineseName : state.englishName)
  }

  /**
   * 分录分组维度
   */
  static entryGroupingDimensionLabelFunc(value) {
    const state = CommonState.getStateByCode(FinanceInterfaceConstants.ENTRY_GROUPING_DIMENSIONS, value)
    return state == null ? '' : (store.getters.isZh ? state.chineseName : state.englishName)
  }

  /**
   * @private
   */
  // static branchIdLabelFunc(item:Object, column:*):String {
  //   if (item[column.dataField] == null)
  //     return "";
  //
  //   var ofc:Office = Office.getOfficeById(item["branchId"]);
  //   return ofc == null ? "" : ofc.code;
  // }

  /**
   * @private
   */
  // static softwareLabelFunc(item:Object, column:*):String {
  //   if (item[column.dataField] == null)
  //     return "";
  //
  //   var code:String = item[column.dataField] as String;
  //   var software:Object = FinanceConfigUtil.getInstance().getSoftwareByCode(code);
  //   return software == null ? "" : software.name;
  // }

  /**
   * @private
   */
  // static schemeLabelFunc(item:Object, column:*):String {
  //   if (item[column.dataField] == null)
  //     return "";
  //
  //   var account:AccountSet = item as AccountSet;
  //
  //   var scheme:Object = null;
  //   if (account)
  //     scheme = FinanceConfigUtil.getInstance().getSchemeByCode(account.softwareVersions, account.interfaceScheme);
  //
  //   return scheme == null ? "" : scheme.name;
  // }

  /**
   * @private
   */
  static operationLabelFunc(value) {
    const state = CommonState.getStateByCode(FinanceInterfaceConstants.OPERATIONS, value)
    return state == null ? '' : state.chineseName
  }

  /**
   * 凭证状态
   */
  static voucherStateLabelFunc(value) {
    const state = CommonState.getStateByCode(FinanceInterfaceConstants.VOUCHER_STATES, Number(value))
    return state == null ? '' : state.chineseName
  }

  /**
   * 合作伙伴类型
   */
  static companyPropertyLabelFunc(value) {
    const state = CommonState.getStateByCode(CompanyConstants.PROPERTIES, Number(value))
    return state == null ? '' : (store.getters.isZh ? state.chineseName : state.englishName)
  }
}

export default FinanceUtil
